function convertSquareMeterToAcre(num) {
  let eq =
    "Converting " +
    num +
    " square meter to acre: \n" +
    num +
    " * 0.0002471053815 = ";
  let rep = num * 0.0002471053815;
  return eq + rep.toFixed(6);
}

function convertSquareMeterToHectare(num) {
  let eq =
    "Converting " +
    num +
    " square meter to hectare: \n" +
    num +
    " * 0.0001 = ";
  let rep = num * 0.0001;
  return eq + rep.toFixed(5);
}

function convertSquareMeterToSquareFoot(num) {
  let eq =
    "Converting " +
    num +
    " square meter to square foot: \n" +
    num +
    " * 10.76391042 = ";
  let rep = num * 10.76391042 ;
  return eq + rep.toFixed(3);
}

function convertSquareMeterToSquareInch(num) {
  let eq =
    "Converting " +
    num +
    " square meter to square inch: \n" +
    num +
    " * 1550.0031 = ";
  let rep = num * 1550.0031;
  return eq + rep.toFixed(3);
}

function convertSquareMeterToSquareMile(num) {
  let eq =
    "Converting " +
    num +
    " square meter to square mile: \n" +
    num +
    " * 3.861021585e-7 = ";
  let rep = num * 3.861021585e-7 ;
  return eq + rep.toFixed(7);
}

function convertSquareMeterToSquareYard(num) {
  let eq =
    "Converting " +
    num +
    " square meter to square yard: \n" +
    num +
    " * 1.195990046 = ";
  let rep = num * 1.195990046;
  return eq + rep.toFixed(3);
}

export {
  convertSquareMeterToAcre,
  convertSquareMeterToSquareYard,
  convertSquareMeterToSquareMile,
  convertSquareMeterToSquareInch,
  convertSquareMeterToSquareFoot,
  convertSquareMeterToHectare
};
